import {
  ApolloClient, ApolloLink, InMemoryCache
} from '@apollo/client'
import { ISocialLink } from '../../../types/user.types'

export function apolloClientFactory(apolloLink: ApolloLink) {
  return new ApolloClient({
    link: apolloLink,
    cache: new InMemoryCache({
      typePolicies: {
        User: {
          // Apollo 3 uses requires a distinct field (default "id" or "_id") to merge cached objects.
          // We need to make sure the field "globalUserId" is present in all query responses.
          keyFields: [ 'globalUserId' ],
          fields: {
            socialLinks: {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              merge(_existing: ISocialLink[] = [], incoming: ISocialLink[] = []) {
                return incoming
              }
            }
          }
        }
      }
    })
  })
}
